module.exports = __webpack_public_path__ + "img/web_2.e5e7e08b.webp";